import React, { useState } from "react";
import { PlusCircleOutlined } from "@ant-design/icons/lib";
import server from "../../../server";
import { firstCharUpperCase } from "../../../utility/utility";
import { Button, Input, Layout, Select, Tag, Form } from "antd";
import resources from "../../../resources";
import CommonTableComponent from "../common-table-component";
import { Leave_Type } from "../../../constant/constant";

function LeavesType() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [allData, setAllData] = useState<any>();
    const leavesRecords = {
        paidType: [
            {value: 'PAID', label: 'Paid'},
            {value: 'UN_PAID', label: 'Unpaid'},
        ],
    }
    const {TextArea} = Input;
    const tempResources = resources.commonButtonText;
    const columns = [
        {
            title: 'Name',
            dataIndex: 'type',
            align: "left",
        },
        {
            title: 'Paid Type',
            dataIndex: 'paidType',
            align: "left",
            render: (data: string) => (
                <Tag className={`status-pill ${data.toLowerCase() === 'paid' ? "active" : "inactive"}`}>
                    {data}
                </Tag>
            )
        },
        {
            title: 'Description',
            dataIndex: 'description',
            align: "left",
        },
        {
            title: 'Created On',
            key: 'createdOn',
            dataIndex: 'createdOn',
            render: (value: any) => value || "-",
            show: true
        },
        {
            title: 'Created By',
            key: 'createdBy',
            dataIndex: 'createdBy',
            show: true
        },
        {
            title: 'Status',
            dataIndex: 'active',
            align: "left",

            render: (active: boolean) => (
                <Tag className={`status-pill ${active ? "active" : "inactive"}`}>
                    {active ? "Active" : "Inactive"}
                </Tag>
            ),
        },
    ];
    const propsData = {
        title: "Leave Type",
        create: server.settings.leaveType.create,
        getAll: server.settings.leaveType.list,
        delete: server.settings.leaveType.delete,
        update: server.settings.leaveType.updateStatus,
        isModalOpen: isModalOpen,
        setIsModalOpen: setIsModalOpen,
        columns: columns,
        allData: allData,
        setAllData: setAllData,
        deleteById: server.settings.leaveType.delete,
        formFields: [
            <Form.Item
                label="Leave Type"
                name="type"
                initialValue={"-Select-"}
                rules={[{required: true, message: 'Please input Leave Type!'}]}>
                <Select placeholder={'-Select-'}>
                    {(Object.keys(Leave_Type) as Array<keyof typeof Leave_Type>).map((key) => (
                        <Select.Option value={key} key={key}>
                            {Leave_Type[key]}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>,

            <Form.Item
                label="Paid Type"
                name={"paidType"}
                initialValue={"-Select-"}
                rules={[{required: true, message: 'Please input Paid Type!'}]}>
                <Select>
                    {leavesRecords.paidType.map((leavesRecords: any) => (
                        <option key={leavesRecords.value} value={leavesRecords.value}>{leavesRecords.label}</option>))}
                </Select>
            </Form.Item>,

            <Form.Item
                label={firstCharUpperCase("description")}
                name={"description"}
                rules={[{required: true, message: `Please input ${firstCharUpperCase(String("description"))}!`}]}>
                <TextArea
                    name={"description"}
                    showCount
                    maxLength={50}
                    placeholder="Description"
                />
            </Form.Item>
        ],
        formFieldsType: [
            {name: "paidType", type: "payloadCode"},
            {name: "type", type: "payloadCode"},
            {name: "description", type: "string"},
            {name: "auditInfo.createdOn", type: "payloadCode"},
            {name: "auditInfo.createdBy", type: "payloadCode"},
        ],
        tableFieldsType: [
            {name: "paidType", type: "string"},
            {name: "type", type: "string"},
            {name: "description", type: "string"},
            {name: "createdOn", type: "date"},
            {name: "createdBy", type: "string"},
        ],
        showStatus: true,
    }

    return (
        <div className="settings-section">
            <div className={'settings-section__heading'}>
                <h4>Leave Type</h4>
                <Button type="primary"
                        icon={<PlusCircleOutlined/>}
                        onClick={() => setIsModalOpen(true)}
                        className="settings-section__action-button">
                    {tempResources.addButton}
                </Button>
            </div>


            <Layout className="settings-section__table-layout">
                <CommonTableComponent propsData={propsData}/>
            </Layout>
        </div>
    )
}

export default LeavesType;
